/**
 * @generated SignedSource<<322b8002746f97a7c4fd0991fcb53970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MediaListCardVideo_instagramMedia$data = {
  readonly id: string;
  readonly mediaUrl: string | null | undefined;
  readonly thumbnailUrl: string | null | undefined;
  readonly " $fragmentType": "MediaListCardVideo_instagramMedia";
};
export type MediaListCardVideo_instagramMedia$key = {
  readonly " $data"?: MediaListCardVideo_instagramMedia$data;
  readonly " $fragmentSpreads": FragmentRefs<"MediaListCardVideo_instagramMedia">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MediaListCardVideo_instagramMedia",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    }
  ],
  "type": "InstagramMediaType",
  "abstractKey": null
};

(node as any).hash = "d49dcf20f08f7f04278a80c7dc9064f2";

export default node;
